// libraries
import React from 'react'
import RatesList from 'components/quote/ltl/ltlLists/ratesList'

function RatesListPage () {
  return <RatesList />
}

export default RatesListPage
